"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default; // 24 hours

var NO_RUSH_TIME = 24;
var RUSH_TIME_MAP = {
  RUSH_EDIT: NO_RUSH_TIME / 2,
  SUPER_RUSH_EDIT: NO_RUSH_TIME / 4
};

function _default(RUSH_EDIT) {
  return RUSH_EDIT && RUSH_EDIT.value ? RUSH_TIME_MAP[RUSH_EDIT.value] : NO_RUSH_TIME;
}